import { FormControlLabel, Grid, Switch, SwitchProps } from '@mui/material';
export type SttFormSwitchProps = {
    name?: string;
    caption?: string;
    color?: SwitchProps['color'];
    checked?: boolean;
    onChange?: ({
        name,
        value,
    }: {
        name: string | undefined;
        value: unknown;
    }) => void;
    grid?: boolean;
    disabled?: boolean;
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
    [key: string]: unknown;
};

/**
 * Form switch
 */
export function SttFormSwitch({
    name,
    caption,
    color,
    checked = false,
    onChange,
    grid = false,
    disabled,
    xs,
    sm,
    md,
    lg,
    xl,
    ...rest
}: SttFormSwitchProps) {
    const content = (
        <FormControlLabel
            control={
                <Switch
                    checked={checked}
                    disabled={disabled}
                    onChange={(e: any) =>
                        onChange?.({
                            name: name || '',
                            value: e.target.checked,
                        })
                    }
                    color={color}
                />
            }
            label={caption}
        />
    );

    const sizeProps = { xs, sm, md, lg, xl };
    return grid ? (
        <Grid size={sizeProps} {...rest}>
            {content}
        </Grid>
    ) : (
        content
    );
}
